import { memo } from "react";
import "../../css/GlobalTextStyles.css";
import { convertToMoney } from "@markit/common.utils";
import { Colors } from "../../utils/colors";

type SubscriptionPlanPriceProps = {
  /** Price in cents (e.g. 1000 for $10). */
  priceInCents?: number;
  /** Pricing page / dark surfaces use white text; subscription flow uses black. */
  homePage?: boolean;
};

const SubscriptionPlanPriceFn = ({
  priceInCents,
  homePage = false,
}: SubscriptionPlanPriceProps) => {
  const resolvedPrice =
    priceInCents !== undefined
      ? priceInCents > 0
        ? convertToMoney(priceInCents / 100)
        : "$0"
      : "";

  const showPerMonth = priceInCents !== undefined && priceInCents > 0;

  const styles = {
    price: {
      fontSize: 24,
      fontWeight: 500,
      color: homePage ? Colors.WHITE : Colors.BLACK,
    },
  };

  if (showPerMonth) {
    return (
      <span style={styles.price}>
        {resolvedPrice}
        <span className="smallBodySubtextMedium"> / mo</span>
      </span>
    );
  }

  return <span style={styles.price}>{resolvedPrice}</span>;
};

const SubscriptionPlanPrice = memo(SubscriptionPlanPriceFn);

export default SubscriptionPlanPrice;
